import script from "./CreatePostModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreatePostModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreatePostModal.vue?vue&type=style&index=0&id=7998a0b1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7998a0b1"]])

export default __exports__